import { all } from 'redux-saga/effects'

import absencesWatcher from './absences/absencesSaga'
import absencesTsWatcher from './absences-ts/absencesSaga'
import appWatcher from './app/appSaga'
import appTsWatcher from './app-ts/appSaga'
import authenticationWatcher from './authentication/authenticationSaga'
import documentsTsWatcher from './documents-ts/documentsSaga'
import exchangesWatcher from './exchanges/exchangesSaga'
import feedbackWatcher from './feedback/feedbackSaga'
import preferenceWatcher from './preferences/preferenceSaga'
import registrationWatcher from './registration/registrationSaga'
import shiftWatcher from './shift/shiftSaga'
import shiftsWatcher from './shifts/shiftsSaga'
import trackWatcher from './track/trackSaga'
import tracksWatcher from './tracks/tracksSaga'
import userWatcher from './user/userSaga'

export default function* rootSaga() {
    yield all([
        appWatcher(),
        appTsWatcher(),
        authenticationWatcher(),
        tracksWatcher(),
        trackWatcher(),
        shiftsWatcher(),
        shiftWatcher(),
        exchangesWatcher(),
        absencesWatcher(),
        absencesTsWatcher(),
        userWatcher(),
        feedbackWatcher(),
        registrationWatcher(),
        documentsTsWatcher(),
        preferenceWatcher(),
    ])
}
